import WelcomeTopbar from "../../../components/common/header/WelcomeTopbar";
import { useStatsAssetStatus } from "../../../api/hooks/stats";
import InventoryWithCustomers from "./InventoryWithCustomers";
import InventoryWithProcessors from "./InventoryWithProcessors";
import { DownloadOutlined } from "@ant-design/icons";
import { useGetAsset } from "../../../api/hooks/asset";
import { message, Spin } from "antd";
import CsvDownloader from "react-csv-downloader";

function InventoryPage() {
  const [messageApi, contextHolder] = message.useMessage();

  const { data } = useStatsAssetStatus();
  const {
    refetch: refetchWarehouseInventoryTags,
    isLoading: isLoadingWarehouseInventoryTags,
  } = useGetAsset({
    params: {
      lastState: ["RETURNED", "DAMAGED", "FIXED", "CLEANED", "ASSIGNED"],
      limit: 50000,
    },
  });

  const {
    refetch: refetchInventoryCirculationTags,
    isLoading: isLoadingInventoryCirculationTags,
  } = useGetAsset({
    params: {
      lastState: ["PROCESSING", "ASSIGNED"],
      limit: 50000,
    },
  });

  async function getWarehouseInvetoryCsvDatas() {
    const { data } = await refetchWarehouseInventoryTags();
    const d =
      data?.data?.map((tagData) => {
        return {
          Tag: tagData?.tag,
          lastState: tagData?.lastState,
        };
      }) || [];
    console.table(d);
    return d;
  }

  async function getInventoryCirculationCsvDatas() {
    const { data } = await refetchInventoryCirculationTags();
    const d =
      data?.data?.map((tagData) => {
        return {
          Tag: tagData?.tag,
          lastState: tagData?.lastState,
        };
      }) || [];
    console.table(d);
    return d;
  }

  function handleEmpty() {
    messageApi.error("Empty CSV Data");
  }

  return (
    <div className="flex flex-col">
      {contextHolder}
      <WelcomeTopbar />
      <div className="flex flex-col gap-6 pb-6">
        <div className="flex flex-col gap-6 pb-6">
          <div className="flex min-h-14 rounded-t-xl bg-[#D1DFFF] px-6 py-3">
            <div className="flex gap-2 text-lg">
              <div>Inventory</div>
            </div>
          </div>
          <div className="flex flex-col gap-6 px-6">
            <div className="flex flex-col gap-4 rounded-xl border-2 pb-4">
              <div className="flex items-center justify-between gap-2 rounded-t-xl bg-[#D1DFFF] px-6 py-2 text-lg">
                <div>Warehouse Inventory</div>
                <div className="flex items-center gap-5">
                  <CsvDownloader
                    datas={getWarehouseInvetoryCsvDatas}
                    filename={`warehouse_inventory.csv`}
                    disabled={isLoadingWarehouseInventoryTags}
                    handleEmpty={handleEmpty}
                  >
                    {isLoadingWarehouseInventoryTags ? (
                      <Spin />
                    ) : (
                      <DownloadOutlined />
                    )}
                  </CsvDownloader>
                </div>
              </div>
              <div className="flex flex-grow justify-between gap-6 divide-x px-16">
                <div className="flex-grow text-center">
                  <p className="">Dirty</p>
                  <p className="font-bold">{data?.RETURNED || 0}</p>
                </div>
                <div className="flex-grow text-center">
                  <p className="">Damaged</p>
                  <p className="font-bold">{data?.DAMAGED || 0}</p>
                </div>
                <div className="flex-grow text-center">
                  <p className="">Fixed</p>
                  <p className="font-bold">{data?.FIXED || 0}</p>
                </div>
                <div className="flex-grow text-center">
                  <p className="">RFU</p>
                  <p className="font-bold">
                    {/* RFU count should only be count in CLEANED */}
                    {data?.CLEANED || 0}
                  </p>
                </div>
              </div>
            </div>
            <div className="flex flex-col gap-4 rounded-xl border-2 pb-4">
              <div className="flex items-center justify-between gap-2 rounded-t-xl bg-[#D1DFFF] px-6 py-2 text-lg">
                <div>Inventory Circulation</div>
                <div className="flex items-center gap-5">
                  <CsvDownloader
                    datas={getInventoryCirculationCsvDatas}
                    filename={`inventory_circulation.csv`}
                    disabled={isLoadingInventoryCirculationTags}
                    handleEmpty={handleEmpty}
                  >
                    {isLoadingInventoryCirculationTags ? (
                      <Spin />
                    ) : (
                      <DownloadOutlined />
                    )}
                  </CsvDownloader>
                </div>
              </div>
              <div className="flex flex-grow justify-between gap-6 divide-x px-16">
                <div className="flex-grow text-center">
                  <p className="">Assigned</p>
                  <p className="font-bold">{data?.ASSIGNED || 0}</p>
                </div>
                <div className="flex-grow text-center">
                  <p className="">Processing</p>
                  <p className="font-bold">{data?.PROCESSING || 0}</p>
                </div>
              </div>
            </div>
            <InventoryWithCustomers />
            <InventoryWithProcessors />
          </div>
        </div>
      </div>
    </div>
  );
}

export default InventoryPage;
